import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent/DataTableLoading'
import { PageHeader } from '@/components/ui/PageHeader'
import { Suspense } from 'react'
import { ProjectsBreadcrumbs } from '../ProjectsBreadcrumbs'
import { ProjectFileManagerPageContent } from './ProjectFileManagerPageContent'

export function ProjectFileManagerPage() {
  return (
    <>
      <PageHeader className="shrink-0 pr-3" title={<ProjectsBreadcrumbs title="File Manager" />} />
      <QueryErrorBoundary errorMessage="Failed to load project files">
        <Suspense fallback={<DataTableLoading />}>
          <ProjectFileManagerPageContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}
